import { ConnectingHardware, Hanger, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

export const connectorDisplayName = (connector: ConnectingHardware): string =>
  connector.standardOrCustom === 'Custom' ? connector.name : connector.model;

export const HangerSchema = new ModelSchema<Hanger>('hanger', {
  category: ModelCategory.ComponentDesignData,

  displayName: (hanger) => connectorDisplayName(hanger.connector),
  properties: {},
});
